<template>
    <div>
        <apply-status-header v-if="getListObj" page-name="応募履歴"></apply-status-header>
        <div class="container">
            <!-- Nav tabs -->
            <ul v-show="getListObj" class="nav nav-tabs tab-sticky breadcrumb p-0 mb-1 nav-justified" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active text-center px-2" data-toggle="tab" href="#open">
                        Open
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-center px-2" data-toggle="tab" href="#closed">
                        Closed
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div id="open" class="container tab-pane active p-0">
                    <!-- Open -->
                    <div v-if="getListObj && getListObj.applyOpen">
                        <div v-if="getListObj.applyOpen.length > 0">
                            <apply-row v-for="(item,idx) in getListObj.applyOpen" :key="item.id" :item="item" :idx="idx" :closed="false"
                                 :class="{'selected-proj':selectedProj == item.id}"></apply-row>
                        </div>
                        <div v-else class="py-5 text-center text-muted">
                            <i class="fas fa-search h1"></i><br>
                            データが見つかりません。
                        </div>
                    </div>
                </div>
        
                <div id="closed" class="container tab-pane fade p-0">
                    <!-- Closed -->
                    <apply-closed-list 
                        ref="list"
                        :has-header="false"
                        mt
                        :mg="false"
                        >
                        <div v-if="getListObj">
                            <div v-if="getListObj.data.length > 0">
                                <apply-row v-for="(item,idx) in getListObj.data" :key="item.id" :item="item" :idx="idx" closed
                                 :class="{'selected-proj':selectedProj == item.id}"></apply-row>
                            </div>
                        </div>
                    </apply-closed-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ApplyStatusHeader from 'pages/commons/header/Header'
import ApplyClosedList from 'pages/commons/List/List'
import ApplyRow from './components/Row'
import {mapGetters} from 'vuex'

export default {
    components: {
        ApplyStatusHeader,
        ApplyClosedList,
        ApplyRow
    },
    mounted () {
        this.$refs.list.loadListObj({ 
            url:'app.status',
            data: '0'
        })
        this.$refs.list.resetRefresh('cmpApplyStatus')
    },
    activated () {
        this.$refs.list.isGetList('cmpApplyStatus', { url:'app.status', data:'0'})
        this.$refs.list.resetRefresh('cmpApplyStatus')
    },
    data () {
        return {
            selectedProj: ''
        }
    },
    watch: {
        $route (to, from) {
            if (from.name == 'ApplyStatusDetail') {
                this.projFromSession()
            } else {
                this.selectedProj = ''
            }
        }
    },
    computed: {
        ...mapGetters(['getListObj'])
    },
    methods: {
        seeMoreMt () {
            this.$store.dispatch('loadListObjSeeMore', {
                url:'app.status',
                skip: this.getListObj.data.slice(-1)[0].id
            })
        },
        projToSession (id) {
            sessionStorage.setItem('applyStatus', id)
        },
        projFromSession () {
            this.selectedProj = sessionStorage.getItem('applyStatus')
        }
    }
}
</script>

<style lang="stylus" scoped>
.selected-proj
    background-color: #4dc0b521
</style>
